/**
 * Logo — the slide-deck mark.
 * Three stacked slides (gold, terra, forest) with white text lines + a gold dot.
 * Scales to any size via the `size` prop. Use this anywhere we need the brand mark.
 */
export default function Logo({ size = 64, withTitle = false, className = '' }) {
  return (
    <span className={`brand-logo ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 220 220"
        width={size}
        height={size}
        aria-label="The Presentation Lab logo"
        role="img"
      >
        {/* Back slide — gold */}
        <g transform="translate(110, 118) rotate(-6)">
          <rect x="-94" y="-66" width="188" height="132" rx="11" fill="#f6c344" />
          <rect x="-94" y="-66" width="188" height="14" fill="#d8a72f" />
        </g>
        {/* Middle slide — terra */}
        <g transform="translate(110, 108) rotate(5)">
          <rect x="-94" y="-66" width="188" height="132" rx="11" fill="#c45c3a" />
          <rect x="-94" y="-66" width="188" height="14" fill="#a0411e" />
        </g>
        {/* Front slide — forest, with text lines + smiley */}
        <g transform="translate(110, 98)">
          <rect x="-94" y="-66" width="188" height="132" rx="11" fill="#3a8a63" />
          <rect x="-94" y="-66" width="188" height="14" fill="#2d6a4f" />
          <rect x="-72" y="-30" width="106" height="8"  rx="4" fill="#ffffff" />
          <rect x="-72" y="-12" width="80"  height="6"  rx="3" fill="#ffffff" opacity="0.85" />
          <rect x="-72" y="4"   width="124" height="6"  rx="3" fill="#ffffff" opacity="0.85" />
          <rect x="-72" y="20"  width="64"  height="6"  rx="3" fill="#ffffff" opacity="0.85" />
          {/* Smiley dot */}
          <g transform="translate(62, 38)">
            <circle cx="0" cy="0" r="13" fill="#f6c344" />
            <circle cx="-3.5" cy="-2.5" r="1.4" fill="#2d6a4f" />
            <circle cx="3.5"  cy="-2.5" r="1.4" fill="#2d6a4f" />
            <path d="M -4.5 2 Q 0 6 4.5 2" stroke="#2d6a4f" strokeWidth="1.6" strokeLinecap="round" fill="none" />
          </g>
        </g>
      </svg>
      {withTitle && (
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.05rem', lineHeight: 1.1, color: 'var(--ink)' }}>
          The Presentation Lab
        </span>
      )}
    </span>
  );
}
